export default "__VITE_ASSET__CNnM3B0M__"